import React from "react";
import { useNavigate } from "react-router-dom";

import Card, { CardBody, CardHeader, CardRow, type CardProps } from "components/partials/card/card";
import ExternalLink from "components/partials/link/link";
import { Button } from "ui/button";

import { ClientAttributes } from "hooks/api/use-clients";

import Icons from "assets";

interface ClientBasicInfoCardProps extends CardProps {
  client: ClientAttributes;
  actions?: React.ReactNode;
}

export const ClientBasicInfoCard: React.FC<ClientBasicInfoCardProps> = ({ client, actions, ...rest }) => {
  const navigate = useNavigate();
  const handleEditClick = () => {
    navigate("edit");
  };

  return (
    <Card {...rest}>
      <div className="flex justify-between items-start mr-4">
        <CardHeader heading="Basic Information" />
        <div className="flex items-center gap-2 mt-4">
          {actions}
          <Button
            variant="outlined"
            size="small"
            startIcon={<Icons.Edit />}
            onClick={handleEditClick}>
            Edit
          </Button>
        </div>
      </div>
      <CardBody>
        <CardRow title="Client name" value={client.name} />
        <CardRow title="Client prefix" value={client.clientCode} />
        <CardRow title="Apollo profile code" value={client.tealiumProfileCode} />
        <CardRow title="Client Apollo URL" value={client.apolloDomainUrl} />
        <CardRow
          title="Client website URL"
          value={
            client.collegeUrl && (
              <ExternalLink href={client.collegeUrl}>{client.collegeUrl}</ExternalLink>
            )
          }
        />
        <CardRow
          title="Client privacy policy URL"
          value={
            client.privacyPolicyUrl && (
              <ExternalLink href={client.privacyPolicyUrl}>{client.privacyPolicyUrl}</ExternalLink>
            )
          }
        />
      </CardBody>
    </Card>
  );
};
